export default __webpack_public_path__ + "static/media/colorblind_grey.430a62c7.svg";